/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Users_Password_OptionalInputs */

const cs_settings_users_password_optional = /** @type {(inputs: Settings_Users_Password_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heslo (volitelné)`)
};

const en_settings_users_password_optional = /** @type {(inputs: Settings_Users_Password_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password (optional)`)
};

/**
* | output |
* | --- |
* | "Password (optional)" |
*
* @param {Settings_Users_Password_OptionalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_password_optional = /** @type {((inputs?: Settings_Users_Password_OptionalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_Password_OptionalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_password_optional(inputs)
	return cs_settings_users_password_optional(inputs)
});